export const DEFAULT_PAGE = {
  new: 9999999999999,
  hot: 0,
  guess: 0,
}

export const DEFAULT_SCORE = 99999

export const SUCCESS_TOPIC_NEW = 21000
